import { CrossIcon } from '../Icons';
import './index.css'

interface SelectionBarProps {
  selectionCount: number;
  onClose?: () => void
  children?: React.ReactNode;
}

const SelectionBar: React.FC<SelectionBarProps> = ({ selectionCount, onClose, children }) => {
  return (
    <div className="selectionbar-section">
      <div className='selectionbar-selection-count'>
        <button className='selectionbar-selection__btn' onClick={onClose}><CrossIcon className='blabla' /></button>
        <div>{selectionCount} seleccionados</div>
      </div>

      <div className="sectionbar-content">{children}</div>

    </div>
  )
}

export default SelectionBar;